import { h, Component } from "preact";
import axios from 'axios';
import style from "./style";
import { getApiPath } from "../../path";

class DatabasesNav extends Component {
  state = {
    routes: [],
    showSubs: false,
    showSubIndex: null,
    dbLoaded: false
  };

  
  componentDidMount() {
    const fetchPath = getApiPath(this.props.locale, 'Menu');
   
      fetch(fetchPath)
      .then(res => res.json())
      .then(result => {
        const {status, data} = result;
        if (data === undefined) {
          data = []
        }
        this.setState(previousState => ({
          ...previousState,
          routes: data,
          dbLoaded: true
        }));
      })
      .catch(error => {
        console.error(
          "There was a problem loading the database from DatabasesNav",
          error
        );
      });
  }

  toggleShowSubs = index => {
    this.setState(previousState => {
      let showSubs = true;
      let showSubIndex = null;
      if (typeof index === "number") {
        showSubIndex = index;
      } else {
        showSubs = !previousState.showSubs;
      }
      if (previousState.showSubIndex === index) {
        showSubIndex = null;
      }
      return {
        ...previousState,
        showSubs,
        showSubIndex
      };
    });
  };

  getDatabaseSubItemClasses = index => {
    const databaseSubItemClasses = [style["nav--types__list--sub"]];
    if (this.state.showSubIndex === index) {
      databaseSubItemClasses.push(style["sub--active"]);
    }

    return databaseSubItemClasses.join(" ");
  };

  render({locale}) {
    const databaseNavClasses = [
      style["nav--types"],
      this.state.showSubs ? style["nav--types--showsubs"] : ""
    ];
    const databaseSubNavClasses = [
      style["nav--types__list"],
      this.state.showSubs ? style["nav--types--showsubsubs"] : ""
    ];

    return (
      <nav class={databaseNavClasses.join(" ")} aria-label="Databases">
        <div class={style["nav--types__label"]} onclick={this.toggleShowSubs}>
          Databases
        </div>
        <ul class={databaseSubNavClasses.join(" ")}>
          {this.state.dbLoaded && this.state.routes.map((route, index) => (
            <li
              class={style["subnav__item"]}
              onclick={this.toggleShowSubs.bind(null, index)}
            >
              {route.label}
              <ul class={this.getDatabaseSubItemClasses(index)}>
                {route.subitems.map(type => (
                  <li>
                    <a class={style['nav__item']} href={`/${locale}/?db=${index}&type=${type.id}`} native>
                      {type.label}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
    );
  }
}

export default DatabasesNav;
